import { Roles } from "../../../constants/roles";
import { NavbarSettingsForm } from "./navbar-settings-form";
import { NavbarSettingsHandler } from "./navbar-settings-handler";
import { NavbarSettingsListener } from "./navbar-settings-listener";

export class NavbarSettingsSetup {
    private readonly form: NavbarSettingsForm;

    private readonly handler: NavbarSettingsHandler;

    private readonly listener: NavbarSettingsListener;

    public constructor(root: HTMLElement) {
        this.form = new NavbarSettingsForm(root);
        this.handler = new NavbarSettingsHandler(this.form);
        this.listener = new NavbarSettingsListener(this.form, this.handler);
    }

    public init(): void {
        if (this.form.isInitialized()) return;

        this.handler.bootstrap();
        this.listener.register();
        this.form.markInitialized();
    }

    public static init(scope: Document | HTMLElement | ParentNode = document): void {
        const root = scope instanceof HTMLElement || scope instanceof Document ? scope : document;

        const targets: HTMLElement[] = [];
        if (root instanceof HTMLElement && root.matches(`[data-role="${Roles.NAVBAR_CONTENT}"]`)) {
            targets.push(root);
        }

        NavbarSettingsForm.getRoots(root).forEach((node) => {
            if (node instanceof HTMLElement) {
                targets.push(node);
            }
        });

        targets.forEach((target) => {
            const setup = new NavbarSettingsSetup(target);
            setup.init();
        });
    }
}
